/**
 * Toast 提示模块
 * 使用 CSS 类 .toast / .toast--visible / .toast--success 等
 */
let toastEl = null;
let hideTimer = null;

function ensureToastEl() {
  if (!toastEl) {
    toastEl = document.createElement('div');
    toastEl.className = 'toast';
    toastEl.setAttribute('role', 'alert');
    toastEl.setAttribute('aria-live', 'polite');
    document.body.appendChild(toastEl);
  }
  return toastEl;
}

export function showToast(message, type = 'success', duration = 3000) {
  const el = ensureToastEl();

  // 清除之前的定时器
  if (hideTimer) clearTimeout(hideTimer);

  // 重置类名
  el.className = 'toast';
  el.textContent = message;

  // 添加类型类
  el.classList.add(`toast--${type}`);

  // 强制回流后显示
  void el.offsetHeight;
  el.classList.add('toast--visible');

  // 自动隐藏
  hideTimer = setTimeout(() => {
    el.classList.remove('toast--visible');
  }, duration);
}
